<template>
  <ActionCardPreview v-bind="previewProps" icon="表" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ActionCardPreview from '../../ActionCardPreview.vue'
import type { WidgetPreviewProps } from '../../types'
import { stringValue } from '../../../previews/preview-helpers'

const props = defineProps<WidgetPreviewProps>()
const previewProps = computed(() => ({
  ...props,
  component: {
    ...props.component,
    props: {
      ...props.component.props,
      title: stringValue(props.component.props?.formCode, '动态表单'),
      subtitle: stringValue(props.component.props?.bizType)
    }
  }
}))
</script>
